import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const resourcesApi = {
  async registry() {
    const response = await apiClient.get("/resources");
    return unwrapEnvelope(response.data, { resources: [], blocked: {} });
  },

  async list(resource, params = {}) {
    const response = await apiClient.get(`/resources/${resource}`, { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async count(resource, params = {}) {
    const response = await apiClient.get(`/resources/${resource}/count`, { params });
    return unwrapEnvelope(response.data, { count: 0 });
  },

  async create(resource, payload) {
    const response = await apiClient.post(`/resources/${resource}`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async update(resource, id, payload) {
    const response = await apiClient.put(`/resources/${resource}/${id}`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async remove(resource, id) {
    const response = await apiClient.delete(`/resources/${resource}/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async listStaffRoster(params = {}) {
    const response = await apiClient.get("/profiles/Staff", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async createStaffRoster(payload) {
    const response = await apiClient.post("/profiles/Staff", payload);
    return unwrapEnvelope(response.data, null);
  },

  async updateStaffRoster(id, payload) {
    const response = await apiClient.put(`/profiles/Staff/${id}`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async removeStaffRoster(id) {
    const response = await apiClient.delete(`/profiles/Staff/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async listStaffMembers(params = {}) {
    const response = await apiClient.get("/staff-members", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async lookupStaffMembers(params = {}) {
    const response = await apiClient.get("/staff-members/lookup", { params });
    const data = unwrapList(response.data);
    return {
      data,
      meta: unwrapMeta(response.data, { total: data.length })
    };
  },

  async getStaffMember(id) {
    const response = await apiClient.get(`/staff-members/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async createStaffMember(payload) {
    const response = await apiClient.post("/staff-members", payload);
    return unwrapEnvelope(response.data, null);
  },

  async updateStaffMember(id, payload) {
    const response = await apiClient.put(`/staff-members/${id}`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async updateStaffMemberStatus(id, isActive) {
    const response = await apiClient.patch(`/staff-members/${id}/status`, { is_active: isActive });
    return unwrapEnvelope(response.data, null);
  },

  async provisionStaffMemberAccess(id, payload) {
    const response = await apiClient.post(`/staff-members/${id}/provision-access`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async updateStaffMemberAccess(id, payload) {
    const response = await apiClient.patch(`/staff-members/${id}/access`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async resendStaffMemberInvite(id) {
    const response = await apiClient.post(`/staff-members/${id}/resend-invite`);
    return unwrapEnvelope(response.data, null);
  },

  async resetStaffMemberPassword(id, payload = {}) {
    const response = await apiClient.post(`/staff-members/${id}/reset-password`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async disableStaffMemberAccess(id) {
    const response = await apiClient.post(`/staff-members/${id}/disable-access`);
    return unwrapEnvelope(response.data, null);
  },

  async removeStaffMember(id) {
    const response = await apiClient.delete(`/staff-members/${id}`);
    return unwrapEnvelope(response.data, null);
  }
};
